import { useEffect } from "react"
import { AUTH_BRAND } from "utils/authPlatform"
import usePlatformAuthChrome from "hooks/usePlatformAuthChrome"
import useTenantAuthChrome from "hooks/useTenantAuthChrome"
import { usePortalTenant } from "context/PortalTenantContext"

/**
 * Shared branding for public auth pages (login, OTP, forgot password, etc.).
 * @param {string} pageTitle — segment before `| Brand`
 */
export default function useAuthPageBranding(pageTitle) {
  const { isCustomLoginActive, tenantName, tenantBranding } = usePortalTenant()
  const brandTitle =
    isCustomLoginActive && tenantName ? tenantName : AUTH_BRAND
  const authPageClassName = isCustomLoginActive ? "login-tenant" : "login-platform"
  const documentTitle = `${pageTitle} | ${brandTitle}`

  useEffect(() => {
    document.title = documentTitle
  }, [documentTitle])

  usePlatformAuthChrome(!isCustomLoginActive, pageTitle)
  useTenantAuthChrome(isCustomLoginActive, documentTitle, tenantBranding)

  return {
    isCustomLoginActive,
    brandTitle,
    tenantBranding,
    authPageClassName,
    documentTitle,
  }
}
